import PropTypes from 'prop-types';
import clsx from 'clsx';
import Image from '@/components/Image';
import Link from '@/components/Link';

const defaultProps = {
  url: null,
  defaultSize: 'w-56 h-56',
  badgeClassName: null,
};

const propTypes = {
  badge: PropTypes.object.isRequired,
  url: PropTypes.string,
  defaultSize: PropTypes.string,
  badgeClassName: PropTypes.string,
};

export default function CertificationBadge({
  badge: {
    node: {
      sourceUrl,
      srcSet,
      sizes,
    },
  },
  url,
  defaultSize,
  badgeClassName,
  title,
}) {
  const hasLink = url !== null;

  const badge = (
    <Image
      src={sourceUrl}
      srcSet={srcSet}
      sizes={sizes}
      alt={title}
    />
  );

  if (hasLink) {
    return (
      <Link href={url} title="Más información">
        <div className="w-36 h-36 bg-gray-100 rounded-full shadow-lg overflow-hidden ring-4 ring-white">
          {badge}
        </div>
      </Link>
    );
  }

  return (
    <div className={clsx(defaultSize, badgeClassName, 'bg-gray-100 rounded-full shadow-lg overflow-hidden')}>
      {badge}
    </div>
  );
}

CertificationBadge.defaultProps = defaultProps;
CertificationBadge.propTypes = propTypes;
